function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.46716 20.1707L8.09545 23.2897L7.93752 12.5323L23.779 3.17289L18.1627 0L2.23265 9.57955L2.46716 20.1707Z",
  fill: "#FF6600"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.9093 30.5019L27.8184 24.2053L18.1173 29.6847L2.21829 20.7327L1.95985 26.7225L18.1292 36L27.9093 30.5019Z",
  fill: "#FF6600"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3414 3.48901L18.8136 6.71341L28.5148 12.1951L28.5411 30.1436L33.9707 27.3665L34.0976 9.02459L24.3414 3.48901Z",
  fill: "#FF6600"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.9016 26.4954L24.3055 32.6679C20.6275 33.6279 16.9471 34.5833 13.2667 35.541C8.84685 31.1529 4.42223 26.767 0 22.3812C0.641319 20.3884 1.27785 18.3957 1.91678 16.403L14.9968 29.1672L25.9495 26.294L25.8992 26.4907L25.9016 26.4954ZM24.1045 32.4735L25.6121 26.6359L14.925 29.4388L2.02925 16.8526L0.277586 22.3156L13.3409 35.2718L24.1021 32.4712L24.1045 32.4735ZM21.6804 7.17471L27.9404 5.43957C30.6278 8.07857 33.3127 10.7199 36.0024 13.3566C34.3321 19.2973 32.6642 25.2379 30.9915 31.1786C28.9096 31.6329 26.8253 32.0872 24.7434 32.5414L29.5007 15.0753L21.4818 7.22857L21.6828 7.17237L21.6804 7.17471ZM27.8687 5.70886L21.9484 7.35033L29.7711 15.0051L25.0832 32.2253L30.7953 30.9796L35.7296 13.4292L27.871 5.70886H27.8687ZM2.22786 16.1852C3.09891 12.7126 3.96995 9.23767 4.83621 5.76272C10.857 4.01587 16.8777 2.262 22.8936 0.503447L27.6772 5.18434L9.77054 10.2516L7.04015 20.8193L2.22786 16.1852ZM2.49827 16.1103L6.90614 20.3557L9.56474 10.0596L27.2082 5.06726L22.8219 0.775075L5.03962 5.95473L2.49827 16.1103Z",
  fill: "#F9F9F9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.901 24.5V12.43H52.165L55.191 18.431H55.225L58.217 12.43H61.498V24.5H58.302V18.567H58.251L56.228 22.324H54.171L52.148 18.533H52.097V24.5H48.901Z",
  fill: "#FF6600"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.2776 24.5V12.43H71.3016V15.303H66.4056V17.122H70.2306V19.876H66.4056V21.627H71.6586V24.5H63.2776Z",
  fill: "#FF6600"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.0563 24.5V12.43H76.1333L80.4003 19.264L80.4343 19.247V12.43H83.6133V24.5H80.4343L76.2523 17.887H76.2183V24.5H73.0563Z",
  fill: "#FF6600"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.9488 17.156L85.4418 12.43H88.3658L87.1248 17.156H84.9488Z",
  fill: "#FF6600"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.2476 24.67C91.6836 24.67 90.0686 24.058 88.7766 22.732L90.6126 20.488C91.5646 21.457 92.6186 21.831 93.3666 21.831C94.1146 21.831 94.4036 21.423 94.4036 21.049C94.4036 20.573 94.1656 20.318 92.8736 19.893C91.0376 19.264 89.2016 18.38 89.2016 15.915C89.2016 13.858 90.9186 12.311 93.2306 12.26C94.8966 12.226 96.3756 12.872 97.4976 13.875L95.7126 16.17C94.6586 15.354 94.0126 15.082 93.4176 15.082C92.8396 15.082 92.5676 15.371 92.5676 15.796C92.5676 16.204 92.8226 16.527 94.0466 17.003C96.1886 17.819 97.8036 18.346 97.8036 20.675C97.8036 23.701 95.2706 24.67 93.2476 24.67Z",
  fill: "#FF6600"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.922 24.5V12.43H106.254V21.627H110.963V24.5H102.922Z",
  fill: "#FF6600"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.221 24.5V12.43H115.553V24.5H112.221Z",
  fill: "#FF6600"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M120.935 24.5L116.515 12.43H120.034L122.346 19.876H122.38L124.709 12.43H128.177L123.774 24.5H120.935Z",
  fill: "#FF6600"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.053 24.5V12.43H137.077V15.303H132.181V17.122H136.006V19.876H132.181V21.627H137.434V24.5H129.053Z",
  fill: "#FF6600"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 138,
    height: 36,
    viewBox: "0 0 138 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "static/media/logo-primary.29e38fb4.svg";
export { SvgComponent as ReactComponent };